import { html, LitElement, nothing } from 'lit';
import { ref } from 'lit/directives/ref.js';

export class BoilerplateModal extends LitElement {
  static get properties() {
    return {
      transparent: { type: Boolean },
      overlay: { type: Boolean },
      class: { type: String },
      zIndex: { type: String },
      position: { type: String },
      open: { type: Boolean },
      title: { type: String, attribute: true },
      detail: { type: Object, state: true },
    };
  }

  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.namespace = this.tagName.toLowerCase();
    this.modalClass = this.namespace.toLowerCase().replaceAll('-', '_');
    this.fromBottom = false;
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      `${this.namespace}:open`,
      this.toggleModal.bind(this)
    );

    document.addEventListener(
      `${this.namespace}:close`,
      this.toggleModal.bind(this)
    );
  }

  handleToggleModal(e) {
    const { target, currentTarget } = e;

    if (target === currentTarget) {
      this.toggleModal(e);
    }
  }

  handleCancel() {
    const body = document.querySelector('body');
    body.classList.remove('overflow-hidden');

    this.open = false;
  }

  toggleModal(e) {
    if (!this.modalRef) {
      return;
    }

    const detail = e?.detail;

    if (detail && !this.open) {
      this.detail = detail;
    }

    this.open = !this.modalRef.open;

    const body = document.querySelector('body');
    body.classList.toggle('overflow-hidden');

    if (!this.open) {
      this.modalRef.close();
      return;
    }

    this.modalRef.showModal();
  }

  renderHeader() {
    return html`
      <h2 id=${`${this.namespace}_title`}>${this.title}</h2>
      <button
        class="_modal_close"
        aria-label="Close"
        @click=${this.toggleModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
            fill="black"
          />
        </svg>
      </button>
    `;
  }

  renderContent() {
    return html`
      <header class="_modal_header">
        <div class="_modal_header_wrapper">${this.renderHeader()}</div>
        <div class="_modal_divider"></div>
      </header>
      <div class="_modal_body">${this.renderBody()}</div>
    `;
  }

  renderBody() {
    return nothing;
  }

  render() {
    return html`
      <dialog
        aria-labelledby=${`${this.namespace}_title`}
        aria-label=${this.title}
        aria-modal="true"
        ?from-bottom=${this.fromBottom}
        ?inert=${!this.open}
        @cancel=${this.handleCancel}
        @click=${this.handleToggleModal}
        tabindex=${this.open ? '0' : '-1'}
        class="${this.class} ${this.zIndex} _modal ${this.modalClass}"
        ${ref((e) => (this.modalRef = e))}
      >
        ${this.renderContent()}
      </dialog>
    `;
  }
}
